App.DeliveryCouriersIndexController = Em.Controller.extend
  needs: ['deliveryCouriers']
  couriersBinding: 'controllers.deliveryCouriers.couriers'

  actions:
    showCourierPage: (courier) ->
      @transitionToRoute('delivery.couriers.show', courier.get('id'))
